export function RealStories() {
  const stories = [
    {
      quote:
        "Dfuse saved me time by thinkingof solutions for a problem with my sister.It helped me understand her point of view.",
      author: "Julia",
      avatar: "/images/avatar-1.svg",
    },
    {
      quote:
        "The app made me realize how small misunderstandings can grow big and how easy it is to fix them when you know how.",
      author: "Adam",
      avatar: "/images/avatar-2.svg",
    },
    {
      quote:
        "I used Dfuse after an argumentat work. It helped me find the right words and rebuild trust with my colleague.",
      author: "Isabella",
      avatar: "/images/avatar-3.svg",
    },
  ];

  return (
    <section
      id="real-stories"
      className="bg-light-light-blue space-y-6 sm:space-y-8 md:space-y-12 lg:space-y-3xl mx-auto px-4 sm:px-6 md:px-10 lg:px-xl py-8 sm:py-12 md:py-16 lg:py-5xl"
    >
      <div className="space-y-2 sm:space-y-4">
        <h2 className="text-greyscale-default font-family-gabarito text-[28px] sm:text-[36px] md:text-[42px] lg:text-[48px] font-bold leading-[32px] sm:leading-[40px] md:leading-[48px] lg:leading-3xl text-center">
          Real stories. Real harmony.
        </h2>
        <p className="text-greyscale-subtle font-family-reddit-sans text-base sm:text-lg md:text-xl leading-[22px] sm:leading-[24px] md:leading-[28px] mx-auto text-center px-4">
          Feedback and impressions from our growing community.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 md:gap-md container mx-auto">
        {stories.map((story) => (
          <div
            key={story.author}
            className="flex p-6 sm:p-8 md:p-xl flex-col items-center gap-4 sm:gap-6 md:gap-l flex-1 rounded-[28px] bg-white shadow-[0_10px_24px_0_rgba(0,0,0,0.06)]"
          >
            <img
              src={story.avatar}
              alt={story.author}
              className="size-[80px] sm:size-[100px] object-cover"
            />
            <div className="flex items-center flex-col">
              <div className="flex items-center gap-1 sm:gap-3xs">
                {Array.from({ length: 5 }).map((_, index) => (
                  <StarIcon key={index} />
                ))}
              </div>
              <p className="text-greyscale-subtle text-center font-family-reddit-sans text-base sm:text-lg font-medium leading-[22px] sm:leading-[24px] mt-1 sm:mt-2xs mb-2 sm:mb-xs">
                {story.quote}
              </p>
              <div className="text-greyscale-default text-center font-family-gabarito text-xl sm:text-2xl font-medium leading-[28px] sm:leading-[32px]">
                {story.author}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function StarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.99991 0.833252C8.19061 0.833312 8.36515 0.942297 8.44913 1.11353L10.3329 4.95435L14.0731 5.50513C14.26 5.53284 14.4152 5.66369 14.4745 5.84302C14.5338 6.02261 14.4864 6.22026 14.3524 6.35376L11.5478 9.14771L12.4872 13.2825C12.5302 13.4718 12.4599 13.6692 12.3065 13.7883C12.1531 13.9073 11.9441 13.9268 11.7714 13.8381L7.99991 11.8948L4.22842 13.8381C4.05574 13.9269 3.84678 13.9072 3.69327 13.7883C3.53987 13.6692 3.4696 13.4719 3.5126 13.2825L4.45108 9.14771L1.64737 6.35376C1.51336 6.22025 1.46603 6.02266 1.5253 5.84302C1.58461 5.66367 1.73981 5.53279 1.92667 5.50513L5.66592 4.95435L7.55069 1.11353C7.6347 0.942292 7.80917 0.833253 7.99991 0.833252Z"
        fill="#FBBC05"
      />
    </svg>
  );
}
